<script setup>
    import { defineProps, defineEmits, computed } from 'vue'

    const props = defineProps({
        label: {
            type: String,
            default: '',
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: '',
            required: true
        },
        modelValue: {
            type: String,
            default: '',
            required: true
        },
        messageError: {
            type: String,
            pattern: null
        },
        class: {
            type: String,
            default: 'webchat-transition outline-none block w-full rounded-md border-gray-300 shadow-sm text-sm focus:ring-2 focus:ring-gray-300 focus:border-transparent'
        }
    })

    const emit = defineEmits(['update:modelValue', 'validate'])

    const strSlug = (str) => {
        return str
            .toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '-')
    }

    const inputEmitted = value => {
        emit('update:modelValue', value)
        emit('validate')
    }

    const getClass = computed(() => {
        return {
            'border-red-500 bg-red-50 focus:ring-red-300': props.messageError,
            'opacity-50 cursor-not-allowed': props.isLoading
        }
    })
</script>

<template>
    <div class="w-full">
        <label
            :for="strSlug(props.label)"
            class="block text-sm font-medium text-gray-700"
        >
            {{ props.label }}
        </label>

        <div class="mt-1">
            <input
                :type="props.type"
                :placeholder="props.placeholder"
                :name="props.label"
                :id="strSlug(props.label)"
                :class="[props.class, getClass ]"
                autocomplete="off"
                :value="props.modelValue"
                :disabled="props.isLoading"
                @input="inputEmitted($event.target.value)"
            />

            <p
                v-if="props.messageError"
                class="mt-2 text-sm text-red-600 input_error"
                :id="strSlug(props.label)"
            >
                {{ props.messageError }}
            </p>
        </div>
    </div>
</template>
